import { render, staticRenderFns } from "./luottoheti.vue?vue&type=template&id=a0cd0172&"
import script from "./luottoheti.vue?vue&type=script&lang=js&"
export * from "./luottoheti.vue?vue&type=script&lang=js&"
import style0 from "./luottoheti.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports